import { map } from 'lodash';

let landingInit;
const entitlementsEndpoint = '/ajax/entitlements';
let entitlementsCopyCache = {};

(function ($) {
  let getIds = function (hits) {
    return map(hits, 'nid');
  };

  landingInit = function (pillar) {
    let rentals = [];
    let id = 0;

    // Collect all rental IDs
    $.each($('[data-search="rentals-text-label"]'), function () {
      id = $(this).data('filmId');
      rentals.push({ nid: id }); //todo: check this!
    });

    if (rentals.length) {
      // Make AJAX request to get entitlement data
      $.ajax(entitlementsEndpoint, {
        method: 'GET',
        contentType: 'application/json',
        data: {
          ids: getIds(rentals).join('|'),
          pillar: pillar, // use dynamic pillar
          type: 'labels',
        },
      }).done(function (data) {
        //console.log(data);

        // Loop over the entitlement data and update the UI
        $.each(data, function (id, message) {
          let $targetElement = $('[data-search="rentals-text-label"][data-film-id="' + id + '"]');
          // If the entitlement message is not empty, update the element
          if (!$.isEmptyObject(message)) {
            if (typeof message['card_expiry'] !== 'undefined') {
              $targetElement
                .attr('data-ent', 'yes')
                .html(message['card_expiry'])
                .closest('.film_card--label')
                .removeClass('d-n')
                .css({ 'background-color': '#FF5555' });
            }
          }
        });
      });
    }
  };
})(jQuery);

const fetchEntitlementCopy = async function (filmId, pillar) {
  try {
    // This endoint is called from multiple components.
    // Results are cached to avoid redundant network requests.
    if (!entitlementsCopyCache[filmId]) {
      const response = await fetch(`${entitlementsEndpoint}?ids=${filmId}&pillar=${pillar}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      entitlementsCopyCache[filmId] = await response.json();
    }
    return entitlementsCopyCache[filmId];
  } catch (error) {
    console.error('Error fetching entitlement CTA:', error);
    throw error;
  }
};

export default {
  landingInit,
  fetchEntitlementCopy,
};
